import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/lib/theme";

export default function ThemeToggle() {
    const { theme, toggle } = useTheme();
    return (
        <button
            type="button"
            onClick={toggle}
            data-testid="theme-toggle"
            aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            className="inline-flex items-center justify-center h-9 w-9 rounded-sm border border-border text-ink-soft hover:text-foreground hover:border-foreground/40 transition-colors"
        >
            {theme === "dark" ? (
                <Sun className="h-4 w-4" strokeWidth={1.5} />
            ) : (
                <Moon className="h-4 w-4" strokeWidth={1.5} />
            )}
        </button>
    );
}
